module.exports = __webpack_public_path__ + "img/eric-och-kattis-1.99cb014f.jpg";